import Vue from 'vue'
import $https from '@/plugins/axios'
import { deepCopy } from '../../utils/Tools/assist'

const findProjectAndReplace = (list, projectId, keys = [], replaceProject = undefined) => {
  for (let i = 0; i < list.length; ++i) {
    const project = list[i]
    if (project.id === projectId && project.spatialCode >= 200000000 && project.spatialCode < 300000000) {
      keys.push(project.spatialCode)
      if (replaceProject) {
        list.splice(i, 1, replaceProject)
        return replaceProject
      }
      return project
    }
    if (project.downdistrict && project.downdistrict.length) {
      const subProject = findProjectAndReplace(project.downdistrict, projectId, keys, replaceProject)
      if (subProject) {
        keys.push(project.spatialCode)
        return subProject
      }
    }
    if (project.downproject && project.downproject.length) {
      const subProject = findProjectAndReplace(project.downproject, projectId, keys, replaceProject)
      if (subProject) {
        keys.push(project.spatialCode)
        return subProject
      }
    }
  }
  return null
}

// eslint-disable-next-line no-unused-vars

const findEnclosure = (list, enclosureId, keys = []) => {
  for (const enclosure of list) {
    if (enclosure.id === enclosureId && enclosure.spatialCode >= 300000000) {
      keys.push(enclosure.spatialCode)
      return enclosure
    }
    if (enclosure.enclosureList && enclosure.enclosureList.length) {
      const subEnclosure = findEnclosure(enclosure.enclosureList, enclosureId, keys)
      if (subEnclosure) {
        keys.push(enclosure.spatialCode)
        return subEnclosure
      }
    }
  }
  return null
}

const fillSubEnclosureLoadedFlag = (list) => {
  for (const enclosure of list) {
    Vue.set(enclosure, 'isSubEnclosureLoaded', true)
    enclosure.enclosureList && fillSubEnclosureLoadedFlag(enclosure.enclosureList)
  }
}

const stateSonar = {
  projectCacheList: [],
  cityProjectEnclosureData: null,
  cityProjectAllData: null
}

const getProjectAndReplaceHelper = (projectId, keys = [], replaceProject = undefined) => {
  let projectData = null
  if (stateSonar.cityProjectEnclosureData) {
    projectData = findProjectAndReplace([stateSonar.cityProjectEnclosureData], projectId, keys, replaceProject)
    if (!projectData) {
      throw new Error('In global tree, no project was found with Id ' + projectId)
    }
  }
  return projectData
}

const getProjectHelper = (projectId, keys = []) => {
  return getProjectAndReplaceHelper(projectId, keys)
}

const gettersSonar = {}

const mutations = {
  PUSH_CACHE_PROJECT: (state, projectData) => {
    state.projectCacheList.push(projectData)
  },
  SET_CITY_PROJECT_ENCLOSURE_DATA: (state, cityProjectEnclosureData) => {
    state.cityProjectEnclosureData = cityProjectEnclosureData
    if (state.projectCacheList.length) {
      for (const project of state.projectCacheList) {
        getProjectAndReplaceHelper(project.id, [], project)
      }
    }
  },
  SET_CITY_PROJECT_All_DATA: (state, cityProjectAllData) => {
    state.cityProjectAllData = cityProjectAllData
  }
}

const _actions = {
  async GetCityProjectAllData ({ state, getters, commit }, { userId, loading = false, serverType = 0 }) {
    let allData = state.cityProjectAllData
    if (!allData) {
      const responseData = await $https.axios({
        method: 'get',
        url: 'SpaceOrg/getCityAndProject',
        params: { userId: userId || getters.user.id },
        loading,
        serverType
      })
      console.log(deepCopy(responseData.data), 90)
      commit('SET_CITY_PROJECT_All_DATA', deepCopy(responseData.data))
      allData = responseData.data
    }
    return deepCopy(allData)
  },
  async GetCityProjectEnclosureData ({ state, getters, commit, dispatch }) {
    if (!state.cityProjectEnclosureData) {
      const responseData = await dispatch('GetCityProjectAllData', { userId: getters.user.id })
      commit('SET_CITY_PROJECT_ENCLOSURE_DATA', deepCopy(responseData))
    }
    return state.cityProjectEnclosureData
  },
  clearCityProjectAllData ({ commit }) {
    commit('SET_CITY_PROJECT_All_DATA', null)
    commit('SET_CITY_PROJECT_ENCLOSURE_DATA', null)
    commit('PUSH_CACHE_PROJECT', [])
  },
  async GetProjectData ({ state, commit }, { projectId }) {
    let projectData = state.projectCacheList.find(item => item.id === projectId)
    if (!projectData) {
      projectData = getProjectHelper(projectId, [])
      if (!projectData) {
        const responseData = await $https.axios({
          method: 'get',
          url: 'SpaceOrg/getProjectInfo',
          params: { projectId }
        })
        // 需要进行二次Project筛选，因为前面请求为异步操作，可能请求前全局树没数据，但请求后却有数据
        projectData = getProjectHelper(projectId, [])
        if (!projectData) {
          projectData = responseData.data
          if (!projectData) {
            throw new Error('In system, no project was found with Id ' + projectId)
          }
        }
      }
      commit('PUSH_CACHE_PROJECT', projectData)
    }
    return projectData
  },
  async GetWholeProjectData ({ dispatch }, { projectId }) {
    const projectData = await dispatch('GetProjectData', { projectId })
    if (!projectData.isWholeProjectDataLoaded) {
      const responseData = await $https.axios({
        method: 'get',
        url: 'SpaceOrg/getEnclosureByProject',
        params: { projectId },
        timeout: 0
      })
      Vue.set(projectData, 'enclosureList', responseData.data)
      Vue.set(projectData, 'isWholeProjectDataLoaded', true)
      fillSubEnclosureLoadedFlag([projectData])
    }
    return projectData
  },
  async GetEnclosureDataUnderProject ({ dispatch }, { projectId }) {
    const projectData = await dispatch('GetProjectData', { projectId })
    if (!projectData.isSubEnclosureLoaded) {
      const responseData = await $https.axios({
        method: 'get',
        url: 'SpaceOrg/getNextEnclosureByProject',
        params: { projectId }
      })
      Vue.set(projectData, 'enclosureList', responseData.data.enclosure)
      Vue.set(projectData, 'isSubEnclosureLoaded', true)
    }
    return projectData.enclosureList
  },
  async GetEnclosureDataUnderEnclosure ({ dispatch }, { projectId, enclosureId }) {
    const projectData = await dispatch('GetProjectData', { projectId })
    if (!projectData.isSubEnclosureLoaded) {
      throw new Error('In global tree, please load enclosure list first for project ' + projectId)
    }
    const enclosureData = findEnclosure(projectData.enclosureList, enclosureId)
    if (!enclosureData) {
      throw new Error('In global tree, no enclosure was found with Id ' + enclosureId + ' in project ' + projectId)
    }
    if (!enclosureData.isSubEnclosureLoaded) {
      const responseData = await $https.axios({
        method: 'get',
        url: 'SpaceOrg/getNextEnclosureByEnclosureId',
        params: { enclosureId }
      })
      Vue.set(enclosureData, 'enclosureList', responseData.data.enclosure)
      Vue.set(enclosureData, 'isSubEnclosureLoaded', true)
    }
    return enclosureData.enclosureList
  },
  async GetProjectDataWithSpecifiedEnclosureData ({ dispatch }, { projectId, specifiedSpatialCode }) {
    const projectData = await dispatch('GetProjectData', { projectId })
    const responseData = await $https.axios({
      method: 'get',
      url: 'SpaceOrg/getUpEnclosureIdListByEnclosureCode',
      params: { enclosureCode: specifiedSpatialCode }
    })
    const enclosureIdList = responseData.data.enclosureIdList
    let enclosureDataList = await dispatch('GetEnclosureDataUnderProject', { projectId })
    for (let i = 0; i < enclosureIdList.length; ++i) {
      if (i !== 0) {
        enclosureDataList = await dispatch('GetEnclosureDataUnderEnclosure', {
          projectId,
          enclosureId: enclosureIdList[i - 1]
        })
      }
      if (!enclosureDataList.find(item => item.id === enclosureIdList[i])) {
        throw new Error('In global tree, enclosure with SpatialCode ' + specifiedSpatialCode + ' is not in project ' + projectId + '. // Info: enclosureIdList is [' + enclosureIdList + ', error enclosureId is ' + enclosureIdList[i] + '], it is not in upper enclosure.')
      }
      if (i === enclosureIdList.length - 1) {
        enclosureDataList = await dispatch('GetEnclosureDataUnderEnclosure', {
          projectId,
          enclosureId: enclosureIdList[i]
        })
      }
    }
    if (!enclosureDataList.find(item => item.spatialCode === specifiedSpatialCode)) {
      throw new Error('In global tree, enclosure with SpatialCode ' + specifiedSpatialCode + ' is not in project ' + projectId + '. // Info: enclosureIdList is ' + (enclosureIdList && enclosureIdList.length ? '[' + enclosureIdList + ']' : 'empty') + ', the specified enclosure is not in the last enclosure.')
    }
    return projectData
  }
}

// 请求拦截，把同一时间一样参数的请求归一成一个真实的网络请求，然后返回同一个Promise给调用者监听
const taskPromiseMap = new Map()
const actions = {}
for (const property in _actions) {
  actions[property] = function () {
    let key = property
    if (arguments[1]) {
      key += ('_' + JSON.stringify(arguments[1]))
    }
    const taskPromise = taskPromiseMap.get(key)
    if (taskPromise) {
      // console.log('Promise Call ' + property)
      return taskPromise
    } else {
      const promise = new Promise(resolve => {
        // console.log('Call ' + property)
        resolve(_actions[property].apply(null, arguments))
      })
      // console.log('set key ' + key)
      taskPromiseMap.set(key, promise)
      promise.then(() => {
        // console.log('resolve key ' + key)
      }).catch(() => {
        // console.log('reject key ' + key)
      }).finally(() => {
        // console.log('delete key ' + key)
        taskPromiseMap.delete(key)
      })
      return promise
    }
  }
}

export default {
  state: stateSonar,
  getters: gettersSonar,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/cityProjectEnclosure.js